// Gastgroepen per widget en de restaurant-opties (golf 2D, besluiten Martijn 11-10-2026).
//
// De winkel heeft hooguit vijf gastgroepen (widgetConfig.fields.field1Text .. field5Text; een lege naam = staat uit). Per widget
// kiest de zaak welke daarvan de gast ziet: de api geeft die lijst in widgetConfig.weergave.gastgroepen (null = alle). Hier
// worden de namen van de andere groepen leeg gemaakt, op een plek (de store, updateWidgetConfig), zodat elk scherm dat de
// gastgroepen toont (restaurant, activiteiten, kaartverkoop, combinatie) het vanzelf goed doet. De namen van de winkel blijven in
// widgetConfig.alleVelden staan, zodat het live voorbeeld een groep ook weer kan laten zien.
//
// Groep 1 staat er altijd in: zonder gasten geen reservering.

/** Het veld van een gastgroep; de activiteitenwidget kent ook "field1" zonder Text. */
const SLEUTELS = (n) => [`field${n}Text`, `field${n}`];

/** De lijst gastgroepen uit de weergave (1-5, met 1 erbij), of null = alle. */
export function gekozenGroepen(weergave) {
    const lijst = weergave?.gastgroepen;
    if (!Array.isArray(lijst)) return null;
    const schoon = lijst.map(Number).filter((n) => Number.isInteger(n) && n >= 1 && n <= 5);
    return [...new Set([1, ...schoon])].sort((a, b) => a - b);
}

/** De namen met alleen de gekozen groepen (de andere leeg). Zonder keuze: precies wat erin ging. */
export function filterVelden(velden, weergave) {
    const groepen = gekozenGroepen(weergave);
    if (!velden || typeof velden !== 'object' || !groepen) return velden;
    const uit = { ...velden };
    for (let n = 2; n <= 5; n++) {
        if (groepen.includes(n)) continue;
        for (const sleutel of SLEUTELS(n)) if (sleutel in uit) uit[sleutel] = '';
    }
    return uit;
}

/**
 * De widgetConfig zoals de store hem bewaart: fields gefilterd op de gastgroepen van deze widget, alleVelden de namen van de
 * winkel. Een config die al door de store ging (met alleVelden) wordt opnieuw gefilterd vanuit alleVelden.
 */
export function metGastgroepen(config) {
    if (!config || typeof config !== 'object') return config;
    const alle = config.alleVelden ?? config.fields;
    if (!alle || typeof alle !== 'object') return config;
    return { ...config, alleVelden: alle, fields: filterVelden(alle, config.weergave) };
}

/** Het live voorbeeld van het scherm Gastgroepen: de namen uit het dashboard over die van de winkel heen. */
export function voegVeldenSamen(config, velden) {
    if (!velden || typeof velden !== 'object') return config;
    const alle = { ...(config?.alleVelden ?? config?.fields ?? {}) };
    for (let n = 1; n <= 5; n++) {
        const sleutel = `field${n}Text`;
        if (sleutel in velden) alle[sleutel] = typeof velden[sleutel] === 'string' ? velden[sleutel] : '';
    }
    return { ...(config || {}), alleVelden: alle, fields: alle };
}

/** Restaurant: de tijden als "lijst" of als "knoppen" (ook voor alles wat onbekend is). */
export function tijdenWeergave(weergave) {
    return String(weergave?.tijdenWeergave || '').toLowerCase() === 'lijst' ? 'lijst' : 'knoppen';
}

/** Restaurant: de tijden die de gast ziet. Met alleenBeschikbareTijden vallen de tijden weg die hij niet kan kiezen. */
export function zichtbareTijden(tijden, weergave, isUit) {
    const lijst = Array.isArray(tijden) ? tijden : [];
    if (weergave?.alleenBeschikbareTijden !== true || typeof isUit !== 'function') return lijst;
    return lijst.filter((t) => !isUit(t));
}

/** Het vak dat het live voorbeeld open zet ("gasten" of "tijden"), of null. */
export function voorbeeldPaneel(waarde) {
    return waarde === 'gasten' || waarde === 'tijden' ? waarde : null;
}

/** Voorbeeldtijden voor het live voorbeeld, als er nog geen echte tijden zijn (geen datum of soort gekozen). Eén is vol. */
export const VOORBEELDTIJDEN = [
    { time: '17:00:00', count: 0 }, { time: '17:30:00', count: 0 }, { time: '18:00:00', count: 0 },
    { time: '18:30:00', count: 0, locked: true, lockedAlert: '' }, { time: '19:00:00', count: 0 }, { time: '19:30:00', count: 0 },
    { time: '20:00:00', count: 0 }, { time: '20:30:00', count: 0 }, { time: '21:00:00', count: 0 },
];
